export var zero = function () { return function () { return ({ payload: {} }); }; };
export var of = function () {
    return function (payload) { return ({ payload: payload }); };
};
